import { FC } from 'react'
import { Wishlist } from '@pylot-data/pylotschema'
import { useTranslation } from 'next-i18next'

export type Props = {
    wishlist: Wishlist
}

export const WishlistCount: FC<Props> = ({ wishlist }) => {
    const { t } = useTranslation(['wishlist'])

    if (!wishlist?.items_count) return null

    return (
        <span>
            {t('wishlist|{{ count }} {{ item }}', {
                count: wishlist!.items_count!,
                item: wishlist!.items_count! > 1 ? 'items' : 'item'
            })}
        </span>
    )
}
